export { default } from './FileInput.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Files/FileInput/index.js